const categories = {
	digital_money: 'digital_money',
	advertising_networks: 'advertising_networks',
	banks: 'banks',
	other: 'other',
	archive: 'archive'
};

const locale = {
	ru: {
		digital_money: 'электронные деньги',
		advertising_networks: 'рекламные сети',
		banks: 'банки',
		other: 'другое',
		archive: 'архив'
	},
	en: {
		digital_money: 'digital money',
		advertising_networks: 'advertising networks',
		banks: 'banks',
		other: 'other',
		archive: 'archive'
	},
	uk: {
		digital_money: 'digital money',
		advertising_networks: 'advertising networks',
		banks: 'banks',
		other: 'other',
		archive: 'archive'
	},
	de: categories,
	vi: categories
};

module.exports = {
	enum: categories,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/payout-system-categories.js